import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const CancelledProjectModal = ({ isOpen, onClose, project }) => {
  if (!isOpen || !project) return null;

  const cancelledDate = new Date(project.updated_at);
  const currentDate = new Date();
  const daysSinceCancelled = Math.floor((currentDate - cancelledDate) / (1000 * 60 * 60 * 24));
  const remainingDays = Math.max(0, 90 - daysSinceCancelled);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-md w-full shadow-xl">
        <div className="p-6">
          {/* 아이콘과 제목 */}
          <div className="flex items-center justify-center mb-4">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
              <ExclamationTriangleIcon className="h-6 w-6 text-red-600" />
            </div>
          </div>
          
          <h3 className="text-lg font-semibold text-center text-gray-900 mb-4">
            취소된 프로젝트입니다
          </h3>

          {/* 안내 내용 */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-600 mb-3">
              취소된 프로젝트는 상태를 변경할 수 없습니다.
            </p>
            
            <div className="space-y-2">
              <div className="flex items-start">
                <span className="text-gray-400 mr-2">•</span>
                <span className="text-sm text-gray-700">
                  {remainingDays > 0 ? (
                    <>고객 열람 가능 기간: <span className="font-medium">90일</span> (<span className="text-blue-600 font-medium">{remainingDays}일 남음</span>)</>
                  ) : (
                    <span className="text-red-600 font-medium">고객 열람 기간이 종료되었습니다</span>
                  )}
                </span>
              </div>
              
              <div className="flex items-start">
                <span className="text-gray-400 mr-2">•</span>
                <span className="text-sm text-gray-700">
                  취소 날짜: {cancelledDate.toLocaleDateString('ko-KR')}
                </span>
              </div>
              
              {project.cancel_reason && (
                <div className="flex items-start">
                  <span className="text-gray-400 mr-2">•</span>
                  <span className="text-sm text-gray-700">
                    취소 사유: {project.cancel_reason}
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* 추가 안내 */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-6">
            <p className="text-xs text-blue-700">
              <span className="font-medium">문의사항이 있으신가요?</span><br />
              관리자에게 연락하시면 도움을 받으실 수 있습니다.
            </p>
          </div>

          {/* 버튼 */}
          <button
            onClick={onClose}
            className="w-full px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelledProjectModal;